export const CLOUD_FRONT_IMAGE_PATH = 'https://dd8f8rnqzvuk.cloudfront.net/images';
